import React from "react";
import { PAGE_GLITCH_OVERLAY_CSS } from "./escapeRoomEditorConstants";
import { isStaggerEffectTransition } from "./escapeRoomStaggerEffectTransitions";

/** Animación del contenedor de página (no usar en glitch: va el overlay). */
export function getPageTransitionWrapperStyle(transitionType, durationMs) {
	const id = String(transitionType || "none");
	if (id === "none") return {};
	if (id === "glitch") {
		const sec = Math.max(0.28, (Number(durationMs) || 500) / 1000);
		return { animation: `er-page-glitch-content ${sec}s ease-out forwards` };
	}
	if (id === "comic" || id === "scatter" || id === "reveal" || isStaggerEffectTransition(id)) return {};
	if (id === "flashEnter" || id === "flashBoth" || id === "flashExit") return {};
	const sec = Math.max(0.15, (Number(durationMs) || 350) / 1000);
	return { animation: `er-page-${id} ${sec}s ease-out forwards` };
}

/**
 * Capa superpuesta sobre el lienzo: aberración cromática, barrido y distorsión breve.
 * La página debajo permanece estable; el efecto se desvanece al terminar.
 */
export default function EscapeRoomPageGlitchOverlay({ durationMs = 500, overlayKey }) {
	const sec = Math.max(0.28, (Number(durationMs) || 500) / 1000);
	return (
		<>
			<style>{PAGE_GLITCH_OVERLAY_CSS}</style>
			<div
				key={overlayKey || "glitch"}
				className="er-page-glitch-overlay"
				style={{ ["--er-glitch-dur"]: `${sec}s` }}
				aria-hidden
			>
				<div className="er-page-glitch-overlay__band er-page-glitch-overlay__band--1" />
				<div className="er-page-glitch-overlay__band er-page-glitch-overlay__band--2" />
				<div className="er-page-glitch-overlay__band er-page-glitch-overlay__band--3" />
				<div className="er-page-glitch-overlay__chroma er-page-glitch-overlay__chroma--a" />
				<div className="er-page-glitch-overlay__chroma er-page-glitch-overlay__chroma--b" />
				<div className="er-page-glitch-overlay__scan" />
				<div className="er-page-glitch-overlay__bars" />
				<div className="er-page-glitch-overlay__flash" />
			</div>
		</>
	);
}
